import { Card, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

// Configuration for a single stat card - accepts pre-translated label
export interface StatConfig {
  icon: LucideIcon;
  value: string | number;
  label: string; // Pre-translated string
  suffix?: string;
  prefix?: string;
}

// Props for the base component
export interface BaseProgressStatsProps {
  stats: StatConfig[];
  isLoading?: boolean;
}

export function BaseProgressStats({ 
  stats, 
  isLoading = false 
}: BaseProgressStatsProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="min-w-0 flex-1 space-y-2">
                  <div className="h-8 w-20 bg-muted rounded" />
                  <div className="h-4 w-28 bg-muted rounded" />
                </div>
                <div className="w-8 h-8 bg-muted rounded-full" />
              </div>
            </CardHeader>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        const displayValue = `${stat.prefix || ''}${stat.value}${stat.suffix || ''}`;
        
        return (
          <Card key={index} className="hover:shadow-lg transition-shadow">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="min-w-0 flex-1">
                  <CardTitle className="text-xl sm:text-2xl md:text-3xl font-bold truncate">
                    {displayValue}
                  </CardTitle>
                  <CardDescription className="text-xs sm:text-sm">
                    {stat.label}
                  </CardDescription>
                </div>
                <Icon className="w-7 h-7 sm:w-8 sm:h-8 flex-shrink-0 text-primary" />
              </div>
            </CardHeader>
          </Card>
        );
      })}
    </div>
  );
}
